import type { RouteLocationNormalized, RouteRecordName } from 'vue-router';
import type { RouteRecordComposite } from '@/types/vueRouter';

import { Views } from '@/router/router.config';

/**
 * Whether a route name belongs to the document editing view.
 *
 * Document routes are declared per product, so they are identified by the
 * `<product>:<view>` suffix rather than by an exhaustive list of names.
 *
 * @param routeName - A route name, e.g. `navigator:Document`
 */
export const isDocumentRouteName = (
  routeName?: RouteRecordName | null,
): boolean => {
  const name = routeName?.toString() ?? '';

  return name.endsWith(`:${Views.DOCUMENT}`)
    || name.endsWith(`:${Views.DOCUMENT_VERSION}`);
};

export function getRouteNames(
  routesList: RouteRecordComposite[],
): string[] {
  return routesList.reduce((acc, { name }) => (
    name && typeof name === 'string'
      ? [...acc, name]
      : acc
  ), [] as string[]);
}

export const getRouteProductName = (to: RouteLocationNormalized): string => (
  to.fullPath.split('/')[1]?.replace(/['"]+/g, '') ?? ''
);
